<template>
  <div v-if="!isConfirmed" class="container text-center">
    <div class="row center-row my-5">
      <div class="col">
        <b-icon
          icon="exclamation-triangle"
          variant="warning"
          scale="5"
        ></b-icon>
      </div>
    </div>
    <div class="row center-row">
      <div class="col">
        <label class="bold-text larger-text">ลบที่อยู่</label>
      </div>
    </div>
    <div class="row center-row">
      <div class="col">
        <label>ต้องการลบ <b>ที่อยู่: "{{shippingAddress.msa_name}}"</b> ของ</label>
      </div>
    </div>
    <div class="row center-row">
      <div class="col">
        <label>ที่อยู่สำหรับจัดส่งเอกสาร หรือไม่?</label>
      </div>
    </div>
    <div class="row center-row mt-3">
      <div class="col">
        <b-button variant="outline-secondary" @click="cancel()" :disabled="isButtonDisabled" class="mr-2">ยกเลิก</b-button>
        <b-button variant="danger" @click="confirm()" :disabled="isButtonDisabled">ยืนยัน</b-button>
      </div>
    </div>
  </div>
  <div v-else class="container text-center">
    <div class="row center-row my-5">
      <div class="col">
        <b-icon
          icon="check-circle"
          style="color: green"
          scale="5"
        />
      </div>
    </div>
    <div class="row center-row">
      <div class="col">
        <label class="bold-text larger-text">ลบที่อยู่สำหรับจัดส่งเอกสารสำเร็จ</label>
      </div>
    </div>
    <div class="row center-row mt-3">
      <div class="col">
        <b-button variant="primary" @click="success()">เสร็จสิ้น</b-button>
      </div>
    </div>
  </div>
</template>

<style>
.center-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
}

.larger-text {
  font-size: 24px; /* Adjust the font size as needed */
}

.warning-icon {
  font-size: 24px;
  color: #f39c12; /* Warning icon color */
}

.bold-text {
  font-weight: bold;
}

/* Add more styling as needed */
</style>

<script>
export default {
  name: "ConfirmModal",
  props: {
    shippingAddress: { type: Object, default: null },
    isConfirmed: { type: Boolean, default: false },
  },
  data() {
    return {
      isButtonDisabled: false, // Initialize the variable to false to enable the button initially
    };
  },
  methods: {
    async confirm() {
      this.isButtonDisabled = true;
      await this.$emit("removeShippingAddressData", this.shippingAddress.msa_id);
    },
    cancel() {
      this.$emit("modalHideRemoveShippingConfirm");
    },
    success() {
      this.$emit("modalHideRemoveShippingConfirm");
    },
  }
};
</script>

